import { FC } from "react";
import { Column } from "../../../components/containers";
import CustomersOptionsSearch from "./customers-options-search";
import CustomersTable from "./customers-table";

const ShowCustomers: FC = () => {
  return (
    <Column
      style={{
        width: "calc(100% - 16px)",
        minHeight: 200,
        margin: "1rem",
        padding: 8,
      }}
    >
      <CustomersOptionsSearch />
      <CustomersTable />
    </Column>
  );
};

export default ShowCustomers;
